import { Footer } from '../components/Footer'

export function Privacy() {
  return (
    <div className="min-h-screen flex flex-col page-content page-container">
      <div className="flex-1 max-w-4xl mx-auto px-4 py-8 w-full">
      <h1 className="text-3xl font-bold mb-6 text-primary">Politique de confidentialité</h1>
      
      <div className="prose max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Collecte des données</h2>
          <p className="mb-4 text-secondary">
            Nous collectons les données suivantes lorsque vous utilisez AgentTeamForge Studio :
          </p>
          <ul className="list-disc list-inside ml-4 space-y-2 text-secondary">
            <li>Données d'identification (nom, email) lors de l'inscription</li>
            <li>Données de connexion (adresse IP, logs) pour la sécurité</li>
            <li>Données d'utilisation (actions effectuées dans l'interface)</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Utilisation des données</h2>
          <p className="text-secondary">
            Vos données personnelles sont utilisées uniquement pour :
          </p>
          <ul className="list-disc list-inside ml-4 space-y-2 mt-2 text-secondary">
            <li>Fournir et améliorer nos services</li>
            <li>Assurer la sécurité de votre compte</li>
            <li>Vous contacter concernant votre compte ou nos services</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Protection des données</h2>
          <p className="text-secondary">
            Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données
            personnelles contre tout accès non autorisé, altération, divulgation ou destruction.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Vos droits</h2>
          <p className="mb-2 text-secondary">
            Conformément au RGPD, vous disposez des droits suivants :
          </p>
          <ul className="list-disc list-inside ml-4 space-y-2 text-secondary">
            <li>Droit d'accès à vos données personnelles</li>
            <li>Droit de rectification des données inexactes</li>
            <li>Droit à l'effacement de vos données</li>
            <li>Droit à la portabilité de vos données</li>
            <li>Droit d'opposition au traitement de vos données</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Contact</h2>
          <p className="text-secondary">
            Pour exercer vos droits ou pour toute question concernant cette politique,
            contactez-nous à :{' '}
            <a href="mailto:support@therapia.solutions" className="action-link">
              support@therapia.solutions
            </a>
          </p>
        </section>
      </div>
      </div>
      <Footer />
    </div>
  )
}

